import { render, staticRenderFns } from "./InvoiceStatusBar.vue?vue&type=template&id=b2412432&scoped=true&lang=pug&"
import script from "./InvoiceStatusBar.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceStatusBar.vue?vue&type=style&index=0&id=b2412432&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2412432",
  null
  
)

export default component.exports